import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { creditApplicationSelectors, creditApplicationEffects } from '../../data/store/CreditApplicationStore'
import { Enum } from '../../data/types/constants'
import { useAppSelector } from '../../data/store'
import { CustomerFeedback } from '../../data/types/CustomerFeedback'
import { useSideEffect } from '../../data/store/Effects/side-effects'

function FeedBackReviewPage() {
  const { t } = useTranslation()
  const dispatchEffect = useSideEffect()
  const creditApplication = useAppSelector(creditApplicationSelectors.getFilteredCreditApplication)
  const navigate = useNavigate()

  const reviewLink = () => {
    if (creditApplication?.loanPurposeId === (Enum.ELoanPurpose.Medical || Enum.ELoanPurpose.Aesthetics)) {
      return Enum.EReviewLink.Medicard
    }
    return Enum.EReviewLink.IFinance
  }

  const postFeedback = () => {
    const dto: CustomerFeedback = {
      withdrawalReasonId: null,
      badReviewReasonId: null,
      contactClient: false,
      isSatisfied: true,
    }

    dispatchEffect(creditApplicationEffects.postCustomerFeedback(dto, creditApplication?.id as string)).then(() =>
      navigate(`/creditApplication/${creditApplication?.id as string}/feedback-page`, { replace: true }),
    )
  }
  const navigateToBadReview = () => {
    navigate(`/creditApplication/${creditApplication?.id}/badReview`, {
      replace: false,
    })
  }

  return (
    <main className="general-message">
      <h4 className="subtitle">{t<string>('common.AnalysisInProgress')}</h4>
      <h3 style={{ alignItems: 'center', textAlign: 'center', justifyContent: 'center' }}>
        {t<string>('feedback.analyzingStatements')}
      </h3>
      {creditApplication?.applicantHasCreditReport && (
        <>
          <br />
          <div style={{ width: '100%' }}>
            <div
              style={{
                width: '100%',
                alignItems: 'center',
                textAlign: 'center',
                justifyContent: 'center',
                margin: 'auto',
                marginTop: '3rem',
              }}
            >
              <h3> {t<string>('feedback.rateYourExperience')}</h3>
            </div>
            <div
              className="button-group-2"
              style={{ justifyItems: 'center', flexDirection: 'row', flexWrap: 'nowrap', alignItems: 'center' }}
            >
              <div
                tabIndex={0}
                role="button"
                style={{
                  width: '50%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={postFeedback}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    postFeedback()
                  }
                }}
              >
                <a
                  href={reviewLink()}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <i className="fa-light fa-thumbs-up" style={{ paddingTop: '6rem', fontSize: '9em' }} />
                  <button
                    type="button"
                    className="btn btn-blue"
                    style={{ justifyContent: 'center', width: '100%', minWidth: '100%' }}
                  >
                    {t<string>('feedback.goodNews')}
                  </button>
                </a>
              </div>
              <div
                tabIndex={0}
                role="button"
                style={{
                  width: '50%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => navigateToBadReview()}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    navigateToBadReview()
                  }
                }}
              >
                <i
                  className="fa-light fa-thumbs-down fa-flip-horizontal"
                  style={{ paddingTop: '6rem', fontSize: '9em', cursor: 'pointer' }}
                />

                <button
                  type="button"
                  className="btn btn-blue"
                  style={{ justifyContent: 'center', width: '100%', minWidth: '100%' }}
                >
                  {t<string>('feedback.badNews')}
                </button>
              </div>
            </div>
            <br />
          </div>
          <br />
        </>
      )}
    </main>
  )
}

export default FeedBackReviewPage
